import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { iCustomerData } from '@/Interfaces/order';
import { getSpecification } from '@/libs/getSpecification';
import { getBase64PDF } from '@/pdf/createPdf';
import { useStoreMeta } from '@/Store/storeMeta';
import router from '@/router';
import { getProjectByUrlParams } from '@/libs/getProject';
import { useStoreNotifications } from '@/Store/storeNotifications';
import { generateNotification } from '@/libs/generateNotification';
import { computeProjectCost } from '@/libs/calcConfigurationCost';
import { cropToNonEmptyPixels } from '@/libs/cropImage';

function getSaveProjectPayload() {
    const configurations = JSON.parse(JSON.stringify(useStoreProjectStructure().getCasesData));
    const selectedCase = useStoreProjectStructure().selectedCaseId;

    // Заменяем на актуальную конфигурацию
    if (selectedCase) {
        configurations[selectedCase] = JSON.parse(JSON.stringify(useStoreCaseConfiguration().$state));
    } else {
        console.warn('Нет выбранного шкафа, спользована исходная конфигурация');
    }

    console.log(configurations);

    const payload = {
        projectId: useStoreProjectStructure().projectId,
        projectName: useStoreProjectStructure().projectName,
        commonData: JSON.parse(JSON.stringify(useStoreProjectStructure().cases)),
        configurationData: configurations,
        specification: getSpecification(configurations),
    };

    console.log('!!!!!payload', payload);

    return payload;
}

export async function saveProject(meta = '') {
    const payload = getSaveProjectPayload();

    try {
        if (payload.commonData && Array.isArray(payload.commonData)) {
            const crop = (url: string) => cropToNonEmptyPixels(url, 10);
            for (const item of payload.commonData) {
                if (item?.image) {
                    try {
                        item.image = await crop(item.image);
                    } catch (e) {
                        console.warn('Crop image failed for case', item.id, e);
                    }
                }
            }
        }
    } catch (e) {
        console.warn('Crop step failed', e);
    }

    window.parent.postMessage({ configurator: {
            action: 'saveProject',
            payLoad: payload,
            meta,
        } }, '*');
}

export async function order(customerData: iCustomerData) {
    const payload = getSaveProjectPayload();

    payload.customerData = customerData; //TODO type
    payload.pdf = await getBase64PDF(); //TODO type

    window.parent.postMessage({ configurator: {
            action: 'order',
            payLoad: payload,
        } }, '*');

    if (useStoreMeta().role) {
        saveProject('order');
    }

}

export async function invoice() {
    const payload = getSaveProjectPayload();

    payload.pdf = await getBase64PDF(); //TODO type

    window.parent.postMessage({ configurator: {
            action: 'invoice',
            payLoad: payload,
        } }, '*');
}

export function sendConfig(config, toolChest) {
    window.parent.postMessage({ configurator: {
            action: 'config',
            payLoad: {
                config: config,
                toolChest: toolChest,
            },
        } }, '*');
}

export function requestMetaData() {
    window.parent.postMessage({ configurator: {
            action: 'getData',
        } }, '*');
}

export function onMessageHandler(message: any) {

    if (!message.data || !message.data.configurator) return;

    if (message.data.configurator.action === 'requestSaveProject') {
        saveProject();
    }

    if (message.data.configurator.action === 'notification') {
        const payload = message.data.configurator.payload;
        if (!payload || !payload.message) return;
        useStoreNotifications()
            .addNotification(generateNotification('projectSaved',payload.message), 2);
        return;
    }

    if (message.data.configurator.action === 'getData') {
        const payload = message.data.configurator.payload;
        console.log('getData ', payload);

        if (!payload) return;

        console.log(payload);
        if (payload.city) {
            useStoreMeta().setCity(payload.city);
        }
        if (payload.currency) {
            useStoreMeta().setCurrency(payload.currency);
        }
        if (payload.dealer) {
            useStoreMeta().setDealer(payload.dealer);
        }
        if (payload.host) {
            useStoreMeta().setHost(payload.host);
        }
        if (payload.role) {
            useStoreMeta().setRole(payload.role);
        }
        if (payload.url) {
            useStoreMeta().setUrl(payload.url);
        }
        if (payload.user) {
            useStoreMeta().setUser(payload.user);
        }
        if (payload.address_email) {
            useStoreMeta().setAddressEmail(payload.address_email);
        }
        if (payload.address_phone) {
            useStoreMeta().setAddressPhone(payload.address_phone);
        }
        if (payload.address_site) {
            useStoreMeta().setAddressSite(payload.address_site);
        }
        if (payload.address_value) {
            useStoreMeta().setAddressValue(payload.address_value);
        }
        if (payload.locker_lid) {
            useStoreMeta().setLockerUUID(payload.locker_lid);
            useStoreProjectStructure().setSelectedCaseId(payload.locker_lid);
        }
        if (payload.project_id) {
            useStoreMeta().setProjectId(payload.project_id);
            useStoreProjectStructure().setProjectId(payload.project_id);
        }

        if (payload.add_locker) {
            useStoreMeta().setAddLockerFlag(payload.add_locker);
        }

        if (payload.name) {
            useStoreMeta().setName(payload.name);
        }

        if (payload.email) {
            useStoreMeta().setEmail(payload.email);
        }

        if (useStoreMeta().projectId && !useStoreMeta().addLockerFlag) {
            getProjectByUrlParams();
        } else {
            const url = new URL(useStoreMeta().url);
            const dataOutCaseItems = url.searchParams.get('config');
            const dataOutToolChest = url.searchParams.get('toolChest');
            if (!dataOutToolChest) return;
            if (!useStoreMeta().addLockerFlag) {
                console.log('addLockerFlag ' + useStoreMeta().addLockerFlag);
                console.log('redirect to configurator');
                router.replace({
                    path: '/configurator',
                    query: {
                        config: dataOutCaseItems,
                        toolChest: dataOutToolChest,
                    },
                });
            }

        }

    }
}

window.testMeta = () => {
    onMessageHandler({
            data:
                {
                    configurator: {
                        action: 'getData',
                        payload: {
                            'url': 'https://dealer.safe.dev3.nowmedia.ru/3/?toolChest=|bntc_1995|clrFrame999993|clrFace00067F|drClosefalse|exDPrId||dS|&config=|sk_40/false/9/0|tcsh_95x47/false/22/0',
                            'dealer': 3,
                            // 'project_id': 64,
                            // 'locker_lid': '54eb8c5f-2f22-4ec4-a833-e984a29c2957',
                            'host': 'https://dealer.safe.dev3.nowmedia.ru/3',
                            'role': 'user',
                            'user': 1,
                            'currency': '€',
                            'city': 'Москва',
                            address_email: 'faje@mailinator.com',
                            address_phone: 'dddd',
                            address_site: 'https://dasdsasd.ru',
                            address_value: 'Architecto veritatis',
                        },
                    },
                },
        },
    );

};
